document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.scroll-down-button')
    const headerElement = document.querySelector('.page-header')

    // Function to handle the smooth scrolling
    function smoothScrollToElement(targetElementSelector) {
        const targetElement = document.querySelector(targetElementSelector)

        if (targetElement) {
            const elementOffsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset
            const headerHeight = headerElement ? headerElement.offsetHeight : 0

            window.scrollTo({
                top: elementOffsetTop - headerHeight,
                behavior: 'smooth'
            })
        }
    }

    // Handle button clicks
    buttons.forEach(function (button) {
        button.addEventListener('click', function (event) {
            const targetElementSelector = button.getAttribute('data-element')
            const targetElementTab = button.getAttribute('data-tab')

            // Check if the clicked element is an <a> tag and points only to a hash
            if (button.tagName.toLowerCase() === 'a') {
                const href = button.getAttribute('href')
                if (href && href.startsWith('#')) {
                    // Prevent the default anchor behavior if it's an internal hash link
                    event.preventDefault()
                } else {
                    // If it's an external link, allow the default behavior
                    return
                }
            }

            // Scroll to the target element
            smoothScrollToElement(targetElementSelector)

            // Update the URL with the new hash
            const newHash = targetElementSelector.startsWith('#') ? targetElementSelector : `#${targetElement.id}`
            history.pushState(null, null, newHash)

            // Dispatch a custom event to select the tab if needed
            if (targetElementTab) {
                window.dispatchEvent(
                    new CustomEvent('select-tab', {
                        detail: {
                            tab: targetElementTab
                        }
                    })
                )
            }
        })
    })

    // Handle page load with a hash in the URL
    if (window.location.hash) {
        smoothScrollToElement(window.location.hash)
    }
})
